export enum AuthStatusTypeEnums {
    LOADING = 0,        // -> 0 Authentication in progress
    SUCCESS = 1,        // -> 1 Authentication successfull
    ERROR = 2,          // -> 2 Authentication failed
    UNKNOWN = 999,      // -> 999 unknown state
}
